import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import SearchFromAutocompleteHotelOffers from './searchFormHotelOfferLandingController';

import '@/css/common/pages/landings/landingHotel.scss';

$(() => {
    new SearchFromAutocompleteHotelOffers({
        el: 'body',
    });
});